const links = [
    {
        title: "Todo List",
        href: "https://yan-todo.herokuapp.com/",
        desc: "This is a simple to-do-list app built with react and react hooks. It has filtering functionality to filter completed and uncompleted. You can also delete completed tasks and mark completed tasks as completed.",
    },
    {
        title: "Drum machine",
        href: "https://codepen.io/yanick-web/full/dyOvGLj",
        desc: "This project was built with react and react hooks. It is a simple drum machine which can be switched on/off, change bank and increase or decrease playback volume."
    },
    {
        title: "Tic tac to game",
        href: "https://codepen.io/yanick-web/full/NWbRXRG",
        desc: "This project was built with JavaScript, html5 and css3. It is a simple tic tac toe game which tracks scores of both players and draws if there are any. However, session information is not stored, therefore all score data is lost when the browser is refreshed."
    },
    
    {
        title: "Calender app",
        href: "https://codepen.io/yanick-web/full/yLbgVWG",
        desc: "A simple calender build with react and react hooks that tracks the current date as well as time and displays them in a nice visual manner."
    }
];
const Builds = () => {

    return (
        <section id="builds" className=" relative text-white h-screen w-full my-8 overflow-hidden ">

            <div className="relative w-full h-full overflow-hidden ">

                <div id="builds-video-container" className=" absolute inset-0 w-full h-full  ">
                    <video className="h-full w-full object-cover rounded-full sm-max:rounded-lg"  muted loop autoPlay>
                        <source src="videos/followart-pixels-video.mp4" type="video/mp4"/>
                        Video element is not supported in this browser.
                    </video>
                </div>

                <h1 className=" relative flex items-center justify-center h-10 w-40 text-2xl rounded-2xl p-4 my-2 bg-gradient-to-br from-customyellow to-customdarkblue ">Builds</h1>

                    <span id="go-left" className="absolute top-3/4 left-0 flex items-center justify-center rounded-full bg-transparent hover:bg-customblue hover:bg-opacity-90 text-2xl text-customyellow w-10 h-10 z-10 cursor-pointer"><i className="fas fa-chevron-left"></i></span>
                    <span id="go-right" className="absolute top-3/4 right-0 flex items-center justify-center rounded-full bg-transparent hover:bg-customblue hover:bg-opacity-90 text-2xl text-customyellow w-10 h-10 z-10 cursor-pointer"><i className="fas fa-chevron-right"></i></span>

                <div id="builds-projects-container" className="relative flex w-full h-4/6 rounded-2xl p-4 my-2 overflow-hidden sm-max:overflow-auto md-min:overflow-auto ">


                    {links.map((link, i)=> <div className=" relative rounded-2xl w-full h-full mr-4 bg-gradient-to-br from-customyellow to-customdarkblue  overflow-hidden sm-max:flex-shrink-0 md-min:flex-shrink-0 md-min:w-1/2" key={i + Date.now()}><img className="absolute top-0 w-1/2 h-full object-cover " src={`images/projects/project-${i + 1}.png`} alt="A glimps of the project"/> 

                        <div className="absolute top-1/4 left-1/3 bg-customblue rounded-2xl p-2 h-3/4 sm-max:overflow-y-scroll">
                            <h2 className="text-2xl text-red-900 ">{link.title}</h2>
                            <p className="text-white text-sm ">{link.desc}</p>
                        </div>
                        <a className="absolute top-0 left-2 text-lg text-white bg-red-900 rounded-2xl p-2 hover:text-customdarkblue focus:text-customyellow  " href={link.href} target="_blank" rel="noopener noreferrer" ><i className="fas fa-external-link-alt"></i></a>
                    </div>)}

                </div>
                <div className="relative flex items-center justify-center w-full h-1/6 p-4 my-2 ">
                    <a className="flex items-center justify-center rounded-2xl text-lg text-white hover:text-customdarkblue focus:text-customyellow w-80 h-10 bg-gradient-to-br from-customyellow to-customdarkblue " href="https://codepen.io/yanick-web" target="_blank" rel="noopener noreferrer" >More on Codepen</a>
                </div>
            </div>
        </section>
    );
};


export default Builds;